import { FC } from "react";
import { Box, Button } from "@chakra-ui/react";

import { useAppModal } from "../../../Modals";
import { OperationItemMonth } from "./OperationItemMonth.tsx";
import { OperationItemContent } from "./OperationItemContent.tsx";
import { OperationItemDetailsModal } from "./OperationItemDetailsModal.tsx";
import { IOperation } from "../../../../../api/operations/types.ts";

interface Props {
  operation: IOperation;
}

export const OperationItem: FC<Props> = ({ operation }) => {
  const { showModal } = useAppModal();

  const pointerEvents = operation.type === "TRANCHE" ? "auto" : "none";

  const onClick = () => {
    showModal({
      content: onClose => <OperationItemDetailsModal operation={operation} onClose={onClose} />,
    });
  };

  return (
    <>
      {operation.isFirstInMonth && <OperationItemMonth date={operation.date} />}

      {/* Для бесконечного скрола важно чтобы у элемента была фиксированная высота и без margin */}
      <Box h="82px" pb="8px">
        <Button
          h="74px"
          w="100%"
          borderRadius="16px"
          display="flex"
          justifyContent="space-between"
          bg="gray.75"
          pointerEvents={pointerEvents}
          onClick={onClick}
        >
          <OperationItemContent operation={operation} />
        </Button>
      </Box>
    </>
  );
};
